import * as React from "react"
import {useMemo, useEffect} from "react"
import {Box} from "@mui/material"
import {AutocompleteAsyncSeeker} from "@ui-seeker/core"

import {BACKEND_APIS} from "@constants"
import {createBatchFormData} from "../../@signals"


export default function TagsAutocomplete({...props}) {
	const customerID = createBatchFormData.value.customerID
	const cid = customerID?.value ?? customerID

	const filters = useMemo(() => (cid ? { customerID: cid } : {}), [cid])

	// Reset selected tags when the customer changes (tags are customer-scoped)
	useEffect(() => {
		if (createBatchFormData.value.tags?.length > 0) {
			createBatchFormData.value = { ...createBatchFormData.value, tags: [] }
		}
	}, [cid])

	return <AutocompleteAsyncSeeker
		multiple
		urlAjax={`${BACKEND_APIS.BATCH_ADMIN}/retailer-tags`}
		label="Tags"
		placeholder={cid ? "Search tags..." : "Select a Customer first"}
		value={createBatchFormData.value.tags}
		onChange={e => createBatchFormData.value = {...createBatchFormData.value, tags: e.target.value}}
		formatOptionLabel={(option) => (
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				{option.color && <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: option.color, border: '1px solid', borderColor: 'divider' }} />}
				<span>{option.label}</span>
			</Box>
		)}
		queryParam="search"
		filters={filters}
		disabled={!cid || props.disabled}
		{...props}
	/>
}
